import React, { type ComponentProps } from 'react'
import { ModalOverlay as RacModalOverlay } from 'react-aria-components'

import { mergeClassNames } from '../utils'

interface ModalBackdropProps extends ComponentProps<typeof RacModalOverlay> {}

export const ModalOverlay = ({
  className,
  useCssAnimation = true,
  ...rest
}: ModalBackdropProps & { useCssAnimation?: boolean }) => {
  return (
    <RacModalOverlay
      className={({ isEntering, isExiting, ...other }) => {
        return mergeClassNames(
          'tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-p-4',
          useCssAnimation && isEntering && 'tw-duration-300 tw-ease-out tw-animate-in tw-fade-in',
          useCssAnimation && isExiting && 'tw-duration-200 tw-ease-in tw-animate-out tw-fade-out',
          typeof className === 'function'
            ? className({ isEntering, isExiting, ...other })
            : className,
        )
      }}
      {...rest}
    />
  )
}

export const FullScreenModalBackdrop = ({
  className,
  useCssAnimation = true,
  ...rest
}: ModalBackdropProps & { useCssAnimation?: boolean }) => {
  return (
    <RacModalOverlay
      className={({ isEntering, isExiting, ...other }) => {
        return mergeClassNames(
          'tw-fixed tw-inset-0 tw-z-50 tw-min-h-full tw-overflow-y-auto tw-bg-black/25',
          'tw-flex tw-items-center tw-justify-center tw-p-4',
          useCssAnimation && isEntering && 'tw-duration-300 tw-ease-out tw-animate-in tw-fade-in',
          useCssAnimation && isExiting && 'tw-duration-200 tw-ease-in tw-animate-out tw-fade-out',
          typeof className === 'function'
            ? className({ isEntering, isExiting, ...other })
            : className,
        )
      }}
      {...rest}
    />
  )
}
